import { HttpClient } from '@angular/common/http';

import { AfterViewInit, Component, ElementRef, Input, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-update-address',
  templateUrl: './update-address.component.html',
  styleUrls: ['./update-address.component.css']
})

export class UpdateAddressComponent implements AfterViewInit{

   @Input() Equitqble:any;
   @Input() Greenshild:any;


   @Input() CloudMD:any;

   @Input() PhzioMSK360:any;

   @Input() SolidGroundMethod:any;

   @Input() Alavida:any;

   @Input() RxFood:any;

   @Input() LifeSpeak:any;



   @Input() lifeSession:any;

   @Input() NortonLifeLock:any;

   @Input() MyHsa:any;
   @Input() historyLength:any;
   @Input() Carequest:any;
   @Input() newsLinkjan:any;
   @Input() newsLinkfed :any;
   @Input() newsLinkmar :any;
   @Input() ENHCanada :any;

  EquitqbleLife: any;

  windowOpen: any;
  updatedWindowLenght: any;
  @Input() lang: any = {};
  formConfiguration: any;


  constructor(private renderer: Renderer2, private el: ElementRef, private http: HttpClient,
  ) { }


  ngOnInit(){
    this.updatedWindowLenght=window.history.length;
  }


  ngAfterViewInit() {
    // Define the scale factor (e.g., 0.8 for 80% zoom)
    const scaleFactor = 1;

    // Get the iframe element
    const iframe = this.el.nativeElement.querySelector('#myIframe');

  }

  getFormConfiguration(lan: any) {
  }



  goBack() {
    setTimeout(() => {
      history.back();
    }, 100);
  }

  close() {
    this.historyLength = 0;
  }



}
